import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SchoolState } from '../reducers/school.reducer';
import { SCHOOL_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<SchoolState>(SCHOOL_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: SchoolState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: SchoolState) => state.loading);
export const selectSchool = createSelector(selectState, (state: SchoolState) => state.school);
export const selectContactEmail = createSelector(selectState, (state: SchoolState) => state.contactEmail);
